import React from 'react';
import { connect } from 'react-redux';
import { compose, is } from 'ramda';

import styleFile from './PaymentPoints.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField';
import RichText from '@synergycms_core/components/generic/RichText'
import actions from '../../../../store/actions';
import { Map } from 'immutable';
import Price from '@synergycms_core/components/generic/Price';

const { customer: customerActions } = actions;


class STPaymentPoints extends React.Component {
  static displayName = 'STPaymentPoints';

  constructor(props) {
    super(props);

    const { defaultValue = 0, reservation } = this.props.config;

    const loyaltyPoints = reservation.getIn(['payment', 'loyalty_points'], false);

    this.state = {
      value: loyaltyPoints || defaultValue
    };
  }


  render() {
    const {
      loyaltyUser,
      reservation,
      loyalty
    } = this.props.config;
    const { classes } = this.props.theme.styles;

    if(!loyalty || !loyaltyUser) {
      return null;
    }
    
    const allow = loyaltyUser.getIn(["points","allow_redem"]);
    const totalPointsPrice = reservation.getIn(['loyalty','total_points_price'], 0);    
    const usedPoints = reservation.getIn(['loyalty','redeem_points'],0);
    const currentPoints =reservation.getIn(["loyalty","current_points"]);
    //"accumulate_points"
    //"current_points"
    //"redeem_points"
    //"total_points_price"

    //const totalPricePoints = Math.trunc(reservation.get(showTaxes ? 'total_price_tax' : 'total_price') * reservation.get("redemption_ratio"));
        
    if(allow) {
      return (
        <div className={classes.inputRange}>
          <label className={classes.checkBox}>
            <CheckboxField
                defaultValue={reservation.getIn(['customer', 'allow_loyalty_point_redemption'], false)}
                type={'checkbox'}
                model={'allow_loyalty_point_redemption'}
                innerStyle={['inputCheck', classes.inputCheck]}
              />              
          </label>
            
            {reservation.getIn(['customer', 'allow_loyalty_point_redemption'], false) ? 
            (<>
              <RichText translate={true} text={"_%Aplicado%_"}/>:<Price amount={totalPointsPrice}/><br/>
              <RichText text={usedPoints}/>{" "}<RichText translate={true} text={"_%puntos canjeados%_"}/><br/>
              <RichText translate={true} text={"_%Crédito restante%_"}/>:<RichText text={currentPoints-usedPoints}/>{" "}<RichText translate={true} text={"_%puntos%_"}/><br/>
            </>) : 
            (<RichText translate={true} text={"_%Pagar con puntos%_"}/>)}
        </div>
      );
    } else {
      return (
        <div className={classes.inputRange}>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%Para canjear puntos se requiere un mínimo de 500, sigue acumulando con tus reservas para poder usarlos pronto%_'}
              />
        </div>
      );
    }
  }
};

const mapDispatchToProps = (dispatch) => {

  return {
    setReservationAmountPromoPaid: (loyalty)=> (reservation, points) => {
      const amountPromoPaid = points * loyalty.get("redemption_ratio");
      dispatch(
        customerActions.reservation.set(
          reservation
            .setIn(['payment', 'amount_promo_paid'], amountPromoPaid)
            .setIn(['payment', 'loyalty_points'], points)
        )
      );
      return true;
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const reservation = store.getIn(['customer', 'reservation']);
  const isNotFinallyConfirmed = !(
    reservation.get('status', false) === 'confirmed' &&
    !(
      (['op', 'amazon_pay'].includes(reservation.getIn(['payment', 'payform_code'], false))) &&
      reservation.getIn(['payment', 'state'], false) === 'pending'
    )
  );

  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;

  return {
    loyaltyUser: store.getIn(['customer', 'loyalty','user'], null),
    loyalty: store.getIn(['customer', 'loyalty', 'data','loyalty'], null),
    reservation: reservation.size > 0 && isNotFinallyConfirmed ? reservation : undefined,
    model: 'applied_points',
    showTaxes: hotel.get('show_taxes')
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    setReservationAmountPromoPaid: dispatchProps.setReservationAmountPromoPaid(stateProps.loyalty),
  });
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  PropertyManager([
    'reservation',
    'loyaltyUser',
    'loyalty',
    'form',
    'model',
    'showTaxes',
    'setReservationAmountPromoPaid'
  ]),
  withThemeJSS({ styleFile, link: true })
)(STPaymentPoints);
